<script>
import AdminLayout from '@/layouts/AdminLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'
import {
  registerSessionExpiredDialog,
  unregisterSessionExpiredDialog,
  resetSessionExpiredDialogGate,
} from '@/utils/sessionExpiredDialog.js'
import { clearTokens } from '@/utils/token.js'

export default {
  name: 'App',
  components: { AdminLayout, BlankLayout },
  data() {
    return {
      sessionExpiredDialog: false,
    }
  },
  computed: {
    currentLayout() {
      if (this.$route.meta?.layout === 'blank') return BlankLayout
      return AdminLayout
    },
  },
  mounted() {
    registerSessionExpiredDialog(({ silent } = {}) => {
      // 들어오자마자 거절당했다 - 들고 온 토큰이 처음부터 무효였다. 모달 없이 로그인으로.
      if (silent) {
        clearTokens()
        this.$router.replace('/login').finally(resetSessionExpiredDialogGate)
        return
      }
      this.sessionExpiredDialog = true
    })
  },
  beforeUnmount() {
    unregisterSessionExpiredDialog()
  },
  methods: {
    onSessionExpiredConfirm() {
      this.sessionExpiredDialog = false
      resetSessionExpiredDialogGate()
      clearTokens()
      this.$router.replace('/login')
    },
  },
}
</script>

<template>
  <v-app class="admin-ui-theme">
    <component :is="currentLayout">
      <router-view />
    </component>

    <v-dialog v-model="sessionExpiredDialog" max-width="400" persistent>
      <v-card rounded="lg">
        <v-card-title class="text-subtitle-1 font-weight-bold pa-5 pb-3">
          알림
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-5 text-body-2">
          로그인이 만료되었습니다. 로그인을 하셔야 합니다.
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4 justify-end">
          <v-btn color="primary" variant="flat" @click="onSessionExpiredConfirm">
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
